import IslamoradaHeroSection from "./components/HeroSection";
import IslamoradaStickyNav from "./components/StickyNav";
import IslamoradaProcessingTimeSection from "./components/ProcessingTimeSection";
import IslamoradaServicesSection from "./components/ServicesSection";
import IslamoradaLocalAreaSection from "./components/LocalAreaSection";
import IslamoradaTravelTimingSection from "./components/TravelTimingSection";
import IslamoradaDestinationsSection from "./components/DestinationsSection";
import IslamoradaTestimonialsSection from "./components/TestimonialsSection";
import IslamoradaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import IslamoradaComparisonSection from "./components/ComparisonSection";
import IslamoradaMistakesSection from "./components/MistakesSection";
import IslamoradaHowItWorksSection from "./components/HowItWorksSection";
import IslamoradaFAQSection, { faqs } from "./components/FAQSection";
import IslamoradaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import IslamoradaFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function IslamoradaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Islamorada"
        state="Florida"
        stateAbbr="FL"
        route="/cities/islamorada"
        title="Emergency Passport Islamorada, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Islamorada, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Monroe County, the Florida Keys, anglers, divers, and travelers."
        geoPlacename="Islamorada, Florida"
        geoPosition="24.9243;-80.6373"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
      />
      <IslamoradaHeroSection />
      <IslamoradaStickyNav />
      <IslamoradaProcessingTimeSection />
      <IslamoradaServicesSection />
      <IslamoradaLocalAreaSection />
      <IslamoradaTravelTimingSection />
      <IslamoradaDestinationsSection />
      <IslamoradaTestimonialsSection />
      <IslamoradaAcceptanceFacilitiesSection />
      <IslamoradaComparisonSection />
      <IslamoradaMistakesSection />
      <IslamoradaHowItWorksSection />
      <IslamoradaFAQSection />
      <IslamoradaHelpfulResourcesSection />
      <IslamoradaFinalCTA />
    </div>
  );
}